import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader } from 'reactstrap';
import ReactToPrint from "react-to-print";
import ReportHeader from './common/ReportHeader';
import ReportFooter from './common/ReportFooter';
import ScrollToTop from './common/ScrollToTop';
import { connect } from 'react-redux';
import CustomerInfoTable_newswiss from './common/CustomerInfoTable_newswiss';
import SwissFrenchPriceTable_v2 from './common/SwissFrenchPriceTable_v2';
import SwissFrenchPriceTableWithGlue_v2 from './common/SwissFrenchPriceTableWithGlue_v2';
import axios from 'axios';
import { configuration } from '../appConfig';
import "./swissfrench.css"
import CarSvgFrench from '../carbodyparts/CarSvgFrench';
import Newswiss_CustomerInfoTable from "./common/newswiss_CustomerInfoTable";
import ReportHeader_Swiss from './common/ReportHeader_Swiss';
import ReportFooter_Swiss from './common/ReportFooter_Swiss';
import ReportAuthorizationHandler from './common/ReportAuthorizationHandler';
import SwissMiniReportAuthorization2 from './common/SwissMiniReportAuthorization2';

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export class ReportMiniFrench extends Component {
  state = {
    lang: '',
    words: {},
    jsonData: {},
    Authorized: "",
    isAnyOnecheck: false,
    isShowReplaceColumn: false,
  }
  async componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    this.getLang();
    this.getData(selectedFile);
  }
  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    let currentLang;
    const { lang, words } = this.state;
    if (lang === "fr") {
      currentLang = "fr-fr";
    } else {
      currentLang = lang;
    }
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getData = async (selectedFile) => {
    axios.get(
      `${configuration.getData}?vin=${selectedFile}&partnerId=${localStorage.getItem("partnerId")}`
    ).then((r) => {
      if (r.data.Authorized) {
        this.setState({
          Authorized: r.data.Authorized,
          jsonData: r.data
        }, () => {
            this.checkStatus()
          })
      } else {
        this.setState({
          Authorized: false,
          jsonData: r.data
        }, () => {
            this.checkStatus()
            this.getFallbackDetails();
          })
      }
    }).catch(error => alert('An error occured please try again'));
  }
  authorize = () => {
    this.props.history.push('/TabViewSwissFrench')
  }
  getFallbackDetails = async () => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await axios.get(url);
      if (res.data) {
        this.setState({
          isShowReplaceColumn: parseInt(res.data.is_show_replace_column) === 1 ? true : false,
        });
      }
    } catch (error) {
      this.setState({
        isShowReplaceColumn: false,
      });
    }
  };
  changeAuthorizeFlag = (authorize, driveType) => {
    this.setState({
      jsonData: {
        ...this.state.jsonData,
        Authorized: authorize,
        DriveThrough:
          driveType === "drive_through"
            ? "0"
            : driveType === "drive_in"
              ? "1"
              : "",
      },
    });
  };

  checkStatus = () => {
    const { jsonData } = this.state;
    const isAnyOnecheck = jsonData && jsonData.Dents && jsonData.Dents.some(item => item.AE && item.AE.length > 0 || item.Ersetzen && item.Ersetzen.length > 0);
    this.setState({ isAnyOnecheck });
  }
  render() {
    const { jsonData, lang, isShowReplaceColumn } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    return (
      <div className="animated fadeIn">
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt-sm-10">
                    <small> <span>{this.lang("VIN Number")} :</span> {localStorage.getItem("selectedFile")}</small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      {/* <button className={`glass btn btn-lg ${this.state.Authorized ? 'btn-success' : 'btn-danger'} mr-1`} onClick={this.authorize}>
                        {this.lang("Authorize PDF")}
                      </button> */}
                      {/* <ReportAuthorizationHandler
                        jsonData={jsonData}
                        lang={this.lang}
                        reportType={"mini"}
                        isRemoveDriveThroughButton={true}
                        isAuthorized={jsonData.Authorized}
                        changeAuthorizeFlag={(authorize, driveType) =>
                          this.changeAuthorizeFlag(authorize, driveType)
                        }
                        selectedLanguage={lang}
                      /> */}
                      <SwissMiniReportAuthorization2 />
                      <ReactToPrint
                        trigger={() => {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg pull-right">
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <CardBody style={{ padding: 0 }}>
            <div
              className="container all-reports-top-wrapper"
              // id="divIdToPrint"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
            >
              <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                <div className="col-sm-12 full-height-col col-zero">
                  <Card>
                    <ReportHeader_Swiss />
                    <CardBody className="col-zero report_swiss_french">
                      <div className="newFormatReport_wrapper">
                        {/* <div className="row w-100"> */}
                        {/* <CustomerInfoTable_newswiss /> */}
                        <Newswiss_CustomerInfoTable />
                        {/* <SwissFrenchPriceTable getUpdatedStateFromPriceTable = {(data)=>this.getUpdatedStateFromPriceTable(data)}/> */}
                        {partnerId == "28-240601" ? (
                              <SwissFrenchPriceTableWithGlue_v2
                                getUpdatedStateFromPriceTable={(data) =>
                                  this.getUpdatedStateFromPriceTable(data)
                                }
                                isUseBasePrice={true}
                              />
                            ) : (
                              <SwissFrenchPriceTable_v2
                                getUpdatedStateFromPriceTable={(data) =>
                                  this.getUpdatedStateFromPriceTable(data)
                                }
                                isUseBasePrice={true}
                              />
                            )}
                        {/* </div> */}
                      </div>
                    </CardBody>
                    <ReportFooter_Swiss />
                    {/* <ReportFooter reportType='newReportFull'/> */}
                  </Card>
                </div>
              </div>
              {this.state.isAnyOnecheck && isShowReplaceColumn &&
                <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                  <div className="col-sm-12 full-height-col col-zero">
                    <Card>
                      <CardBody className="col-zero">
                        <div className="newFormatReport_wrapper">
                          <ReportHeader_Swiss />
                          {partnerId == "28-240601" ? (
                            <SwissFrenchPriceTableWithGlue_v2
                              getUpdatedStateFromPriceTable={(data) =>
                                this.getUpdatedStateFromPriceTable(data)
                              }
                              isUseBasePrice={false}
                              is_extra_columns_visible_mini_fullreport={true}
                            />
                          ) : (
                            <SwissFrenchPriceTable_v2
                              getUpdatedStateFromPriceTable={(data) =>
                                this.getUpdatedStateFromPriceTable(data)
                              }
                              isUseBasePrice={false}
                              is_extra_columns_visible_mini_fullreport={true}
                            />
                          )}
                          {/* <div className="p-0 row ">
                    </div> */}
                        </div>
                      </CardBody>
                      <ReportFooter_Swiss />
                    </Card>
                  </div>
                </div>
              }
              <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                <div className="col-sm-12 full-height-col col-zero">
                  <Card>
                    <CardBody className="col-zero">
                      <div className="newFormatReport_wrapper">
                        <ReportHeader_Swiss />
                        <div className="container car-svg-main">
                          <div className="row title-row-main">
                            <div className="col-sm-12 col-zero">
                              <h3 className='report-title'>
                                {this.lang("2D")}<span> {this.lang("View")}</span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row row-zero">
                            <div className="col-sm-12 text-center">
                              <CarSvgFrench {...this.props} reportType='newReportFull' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    <ReportFooter_Swiss />
                    {/* <ReportFooter reportType='newReportFull'/> */}
                  </Card>
                </div>
              </div>
            </div>
          </CardBody>
          {/* <div>
            <Card>
              <CardBody>
                <Link className="glass" to="/ReportFull">
                  <button className="btn btn-danger btn-sm pull-right">
                    <i className="fa fa-dot-circle-o"></i> {">>"}
                  </button>
                </Link>
                <Link className="glass" to="/TabView">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn btn-danger btn-sm pull-right"
                  >
                    {"<<"} <i className="fa fa-dot-circle-o"></i>
                  </button>
                </Link>
              </CardBody>
            </Card>
          </div> */}
        </div>
        <div>
          <ScrollToTop />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(ReportMiniFrench);